import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Grid,
  List,
  ListItem,
  ListItemButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { EventContext } from "../../contexts/EventContext";
import formatDate from "../../utilities/formatDate";
import request from "../../utilities/requests";
import { toast } from "../../utilities/SnackBarUtils";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AssignUserEvent = ({ open, close, user, action, eventType }) => {
  const { userData } = React.useContext(EventContext);
  const [profile, setProfile] = React.useState({});
  const [events, setEvents] = React.useState([]);
  const [retrievedEvents, setRetrievedEvents] = React.useState(false);
  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const [selectedEvent, setSelectedEvent] = React.useState(null);

  React.useEffect(() => {
    if (user) {
      setProfile(user.profile);
    }
  }, [user]);

  // React.useEffect(() => {
  //   if (events.length === 0 && !retrievedEvents) {
  //     if (!eventType) {
  //       getPairingEvents();
  //     } else if (eventType === "exchange") {
  //       getExchangeEvents();
  //     }
  //   }
  // }, [events, eventType]);

  React.useEffect(() => {
    if (!eventType) {
      getPairingEvents();
    } else if (eventType === "exchange") {
      getExchangeEvents();
    }
  }, [eventType]);

  const getPairingEvents = async () => {
    const result = await request("pairingevent");

    if (result.success) {
      setRetrievedEvents(true);
      setEvents(result.pairingEvents);
    }
  };

  const getExchangeEvents = async () => {
    const result = await request("exchange/exchangeEvents");
    if (result.success) {
      setRetrievedEvents(true);
      setEvents(result.data);
    }
  };

  const renderList = () => {
    if (eventType === "exchange") {
      return events.map((event) => {
        return (
          <div key={event._id}>
            <ListItem>
              <ListItemButton
                onClick={() => {
                  setConfirmOpen(true);
                  setSelectedEvent({ event });
                }}
              >
                {event?.name}
              </ListItemButton>
            </ListItem>
            <Divider />
          </div>
        );
      });
    }

    return events.map((pairingEvent) => {
      return (
        <div key={pairingEvent._id}>
          <ListItem>
            <ListItemButton
              onClick={() => {
                setConfirmOpen(true);
                setSelectedEvent(pairingEvent);
              }}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              {pairingEvent?.event?.name} |{" "}
              <strong>{formatDate(pairingEvent?.event?.date)}</strong>
            </ListItemButton>
          </ListItem>
          <Divider />
        </div>
      );
    });
  };

  const handleAssign = async () => {
    setConfirmOpen(false);

    let body;
    if (eventType === "exchange") {
      body = {
        userId: user._id,
        eventId: selectedEvent.event.event._id,
      };
    } else {
      body = {
        userId: user._id,
        eventId: selectedEvent.event._id,
      };
    }

    if (action === "assign") {
      const result = await request("events/addattendee", "post", body);
      if (result.success) {
        toast.success("User assigned to event");
        close();
      }
    } else if (action === "remove") {
      const result = await request("events/removeattendee", "post", body);
      if (result.success) {
        toast.success("User removed from event");
        close();
      }
    }
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={close}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={close}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Click on an event to {action}
            </Typography>
          </Toolbar>
        </AppBar>
        <Grid container direction="column" spacing={3} style={{ padding: 20 }}>
          {action === "assign" && userData?.org?.config?.ticketingEnabled ? (
            <Typography variant="h6" sx={{p: 5}}>Since you have ticketing enabled on this system, you cannot assign attendees here. Please go to the Event → Actions → Add Attendee to add the user to the event.</Typography>
          ) : (
            <List>{renderList()}</List>
          )}

          <Grid item></Grid>
        </Grid>
      </Dialog>
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle id="alert-dialog-title">
          Confirm {action === "assign" ? "Assignment" : "Removal"}
        </DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to {action} {user?.profile?.firstName}{" "}
            {action === "assign" ? "to" : "from"} the{" "}
            {selectedEvent?.event?.name}?
          </Typography>
          {userData?.org?.config?.ticketingEnabled ? (
            <Typography style={{ paddingTop: 20 }}>
              Removing an attendee here will <strong>not</strong> issue a
              refund. If the ticket was purchased through this system, please
              refund via Users → Search Attendee. From there, you can also
              remove them from the event. Note: if you remove them here, ticket
              availability will update on this system and any linked platforms.
              (similar to refunds)
            </Typography>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button onClick={handleAssign} autoFocus>
            {action}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AssignUserEvent;
